// extracted by mini-css-extract-plugin
export default {"viberLogo":"Viber_viberLogo__eqAyp","phoneContainer":"Viber_phoneContainer__jUYpm","phoneLink":"Viber_phoneLink__vfKSn"};